import type { Options, PlatformV1LoginResponse, V1User } from '../client'

import { client } from '../client/client.gen'

export interface PlatformV1FeishuLoginRequest {
  code: string
  redirectUri?: string
}

export interface PlatformV1FeishuLoginResponse extends PlatformV1LoginResponse {
  bindingCreated?: boolean
  requiresAccountSelection?: boolean
  pendingToken?: string
  feishuUser?: PlatformV1FeishuProfile
  bindableUsers?: V1User[]
}

export interface PlatformV1FeishuProfile {
  providerUserId?: string
  openId?: string
  unionId?: string
  email?: string
  username?: string
}

export interface PlatformV1CompleteFeishuLoginRequest {
  pendingToken: string
  userId?: string
  createNewUser?: boolean
}

export interface PlatformV1CompleteFeishuLoginResponse extends PlatformV1LoginResponse {
  bindingCreated?: boolean
  userCreated?: boolean
}

export interface AuthServiceFeishuLoginData {
  body: PlatformV1FeishuLoginRequest
  path?: never
  query?: never
  url: '/v1/auth/feishu/login'
}

export function authServiceFeishuLogin<ThrowOnError extends boolean = false>(
  options: Options<AuthServiceFeishuLoginData, ThrowOnError>,
) {
  return (options.client ?? client).post<PlatformV1FeishuLoginResponse, unknown, ThrowOnError>({
    url: '/v1/auth/feishu/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}

export interface AuthServiceCompleteFeishuLoginData {
  body: PlatformV1CompleteFeishuLoginRequest
  path?: never
  query?: never
  url: '/v1/auth/feishu/complete'
}

export function authServiceCompleteFeishuLogin<ThrowOnError extends boolean = false>(
  options: Options<AuthServiceCompleteFeishuLoginData, ThrowOnError>,
) {
  return (options.client ?? client).post<PlatformV1CompleteFeishuLoginResponse, unknown, ThrowOnError>({
    url: '/v1/auth/feishu/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
}
